export default __webpack_public_path__ + "static/Metal_Catwalk-8d85de4cebff47a7d69686af49a4cbf8.png";